export default [
    {
        path: '/:cid/document',
        name: 'documents',
        meta: {
            title: "Documents",
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "project" */ '@/views/Documents/Documents.vue'),
    },
]